export * from './orderService.service';
import { OrderServiceService } from './orderService.service';
export const APIS = [OrderServiceService];
